import * as countries from "i18n-iso-countries";
import cs from "i18n-iso-countries/langs/cs.json";

export interface CountryOption {
  value: string;
  label: string;
}

countries.registerLocale(cs);

const collator = new Intl.Collator("cs", { sensitivity: "base" });

export const COUNTRY_OPTIONS: CountryOption[] = Object.entries(
  countries.getNames("cs", { select: "official" }),
)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) => collator.compare(a.label, b.label));
